import { render, staticRenderFns } from "./UploadBackgroundImage.vue?vue&type=template&id=20cb1c92&scoped=true&"
import script from "./UploadBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./UploadBackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./UploadBackgroundImage.vue?vue&type=style&index=0&id=20cb1c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb1c92",
  null
  
)

export default component.exports